import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    Button,
    InputControl,
    CheckboxControl,
    SegmentLoader,
    Row,
    Col,
    ButtonGroup,
} from '@si-armes/dsfr-react';
import { FormProvider, useForm } from 'react-hook-form';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import FileUploadeAbstract from 'components/Commun/Form/InputFiles/Model/FileUploadeAbstract';
import { getTelFormatWithoutSpace } from 'components/Commun/Form/maskFunctions';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_COMPTE_CREER_ADRESSE_PRINCIPALE_URL,
    API_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2_URL,
    API_POST_VERIFIER_BAN,
    CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE,
    CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2,
    CONTEXT_POST_VERIFIER_BAN,
    API_COMPTE_CREER_ADRESSES_SECONDAIRES_URL,
    CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES,
} from 'constants/apiUrls.constants';
import { REGEXP_EMAIL } from 'constants/contraintes.constants';
import { getMessageErreurChampManquant } from 'utils/utils';
import ModalBan from 'components/modalBan/ModalBan';
import FormulaireAdresseSimple from 'components/form/formulaireAdresse/FormulaireAdresseSimple';
import FormulaireJustificatifsDomicile from 'components/form/formulaireAdresse/FormulaireJustificatifsDomicile';
import formaterCreationAdressePrincipal from '../../adresse/FormaterCreationAdressePrincipal';
import InfoChampsObligatoire from '../../../../../../../components/form/infoObligatoire/InfoChampsObligatoire';
import { hideAllNotification } from '../../../../../../../store/alertes/alertesReducer';
import FormaterCreationListeAdressesSecondaires from '../../adresseSecondaire/FormaterCreationListeAdressesSecondaires';
import TableAdressesComponent from '../../../../../../../components/table/TableAdressesComponent';

const CoordonneesDetenteurPhysique = ({
    uuidBrouillon,
    postApi,
    reinitialiseApi,
    data,
    isLoading,
    retourEtape,
    setEtapeCoordonnees,
    isLoadingRenseignerAdressePrincipale,
    dataRenseignerAdressePrincipale,
    dataAdressePrincipaleRenseignee,
    isLoadingJustificatifsDomicile,
    dataRenseignerJustificatifsDomicile,
    erreurJustificatifsDomicile,
    dataCodePostal,
    clearAlertes,
    isLoadingAjoutAdresseSecondaire,
    dataAjoutAdresseSecondaire,
    dataAdressesSecondairesRenseignee,
}) => {
    const hookForm = useForm({
        mode: 'onChange',
        defaultValues: { ...dataAdressePrincipaleRenseignee },
    });
    const { handleSubmit, register, formState, watch, reset, setValue, unregister } = hookForm;
    const { isValid } = formState;
    const [adresseResponsable, setAdresseResponsable] = useState(null);
    const [ouvrirModalBan, setOuvrirModalBan] = useState(false);
    const [justificatifsDomicile, setJustificatifsDomicile] = useState(null);

    const [listeAdresses, setListeAdresses] = useState(dataAdressesSecondairesRenseignee || []);
    const [affichageFormulaire, setAffichageFormulaire] = useState(false);
    const [dataToSubmit, setDataToSubmit] = useState(null);
    const [ouvrirModalBanSecondaire, setOuvrirModalBanSecondaire] = useState(false);

    const afficherFormulaire = () => {
        setAffichageFormulaire(true);
    };

    const suppressionLigneTableau = (table, index) => {
        table.splice(index, 1);
        return [...table];
    };

    const supprimerLigne = (idBouton) => {
        setListeAdresses(suppressionLigneTableau(listeAdresses, idBouton));
    };

    const getActions = (idBouton) => {
        return (
            <>
                <Button
                    icon="fr-fi-delete-fill"
                    variant="secondary"
                    onClick={() => supprimerLigne(idBouton)}
                    aria-label="Supprimer une adresse secondaire"
                    type="button"
                />
            </>
        );
    };

    const addToListeAdresse = (dataSecondaire) => {
        setListeAdresses([...listeAdresses, dataSecondaire]);
    };

    const resetForm = () => {
        setValue('adresseSecondaire.numeroDeVoie', '');
        setValue('adresseSecondaire.extension', '');
        setValue('adresseSecondaire.typeEtNomDeVoie', '');
        setValue('adresseSecondaire.lieuDit', '');
        setValue('adresseSecondaire.codePostal', '');
        setValue('adresseSecondaire.ville', '');
    };

    const cacherFormulaire = () => {
        setAffichageFormulaire(false);
        unregister('adresseSecondaire.numeroDeVoie');
        unregister('adresseSecondaire.extension');
        unregister('adresseSecondaire.typeEtNomDeVoie');
        unregister('adresseSecondaire.lieuDit');
        unregister('adresseSecondaire.codePostal');
        unregister('adresseSecondaire.ville');

        resetForm();
    };

    const requetePostAdresse = (donnees) => {
        reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES);
        postApi(
            usagerClientReducer,
            API_COMPTE_CREER_ADRESSES_SECONDAIRES_URL,
            donnees,
            CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES,
        );
    };

    const verifierBan = (dataGlobal) => {
        const adresseAverifier = {
            numeroVoie: dataGlobal.adresseSecondaire.numeroDeVoie,
            libelleVoie: dataGlobal.adresseSecondaire.typeEtNomDeVoie,
            codePostal: dataGlobal.adresseSecondaire.codePostal,
            ville: dataGlobal.adresseSecondaire.ville,
            extension: dataGlobal.adresseSecondaire.extension ?? '',
            lieuDit: dataGlobal.adresseSecondaire.lieuDit,
        };

        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
        postApi(
            usagerClientReducer,
            API_POST_VERIFIER_BAN,
            adresseAverifier,
            CONTEXT_POST_VERIFIER_BAN,
        );
        setDataToSubmit({
            ...dataGlobal.adresseSecondaire,
            extension: dataGlobal.adresseSecondaire.extension ?? '',
        });
        setOuvrirModalBanSecondaire(true);
    };

    const onRetourEtape = () => {
        setAffichageFormulaire(false);
        resetForm();
        retourEtape(listeAdresses);
    };

    const onEtapeSuivante = async () => {
        const dataSecondaire = FormaterCreationListeAdressesSecondaires(
            listeAdresses,
            uuidBrouillon,
        );
        requetePostAdresse(dataSecondaire);
        setAffichageFormulaire(false);
        resetForm();
    };

    const fermerModal = () => {
        setOuvrirModalBan(false);
        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
    };
    const fermerModalSecondaire = () => {
        setOuvrirModalBanSecondaire(false);
        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
    };

    const conserverSecondaire = () => {
        fermerModalSecondaire();
        addToListeAdresse({ ...dataToSubmit, hasVerificationBan: false });
        setAffichageFormulaire(false);
        resetForm();
    };

    const remplacerSecondaire = () => {
        fermerModalSecondaire();
        addToListeAdresse({
            ...dataToSubmit,
            numeroDeVoie: data.numeroVoie,
            typeEtNomDeVoie: data.libelleVoie,
            extension: data.extension ?? '',
            lieuDit: data.lieuDit,
            codePostal: data.codePostal,
            ville: data.ville,
            hasVerificationBan: true,
        });
        setAffichageFormulaire(false);
        resetForm();
    };

    // on mount et unmount
    useEffect(() => {
        window.scrollTo(0, 0);
        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
        reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE);
        if (
            dataAdressePrincipaleRenseignee &&
            dataAdressePrincipaleRenseignee.justificatifsDomicile
        ) {
            setValue(
                'justificatifsDomicile',
                dataAdressePrincipaleRenseignee.justificatifsDomicile,
            );
        }

        return () => {
            reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
            reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE);
        };
    }, []);

    async function postJustificatifsDomicile() {
        reinitialiseApi(
            CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2,
        );
        justificatifsDomicile.forEach((value, index) => {
            postApi(
                usagerClientReducer,
                API_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2_URL.replace(
                    '{index}',
                    index + 1,
                ),
                {
                    justificatifDomicile: value,
                    key: index + 1,
                    uuidBrouillon,
                },
                CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2,
            );
        });
    }

    useEffect(() => {
        if (
            !isLoadingRenseignerAdressePrincipale &&
            dataRenseignerAdressePrincipale &&
            dataRenseignerAdressePrincipale.uuidBrouillon
        ) {
            setOuvrirModalBan(false);

            if (justificatifsDomicile) {
                postJustificatifsDomicile();
            }
        }
    }, [isLoadingRenseignerAdressePrincipale, dataRenseignerAdressePrincipale]);

    useEffect(() => {
        if (
            !isLoadingAjoutAdresseSecondaire &&
            dataAjoutAdresseSecondaire &&
            dataAjoutAdresseSecondaire.uuidBrouillon
        ) {
            setOuvrirModalBan(false);
        }
    }, [isLoadingAjoutAdresseSecondaire, dataAjoutAdresseSecondaire]);

    function conditionPourPasserEtapeSuivante() {
        const adresseEnvoyee =
            !isLoadingRenseignerAdressePrincipale &&
            dataRenseignerAdressePrincipale &&
            dataRenseignerAdressePrincipale.uuidBrouillon;

        const justificatifDomicileEnvoyee =
            isLoadingJustificatifsDomicile === false &&
            dataRenseignerJustificatifsDomicile &&
            !erreurJustificatifsDomicile;

        const adresseSecondaireEnvoyee =
            !isLoadingAjoutAdresseSecondaire && dataAjoutAdresseSecondaire;

        return adresseEnvoyee && justificatifDomicileEnvoyee && adresseSecondaireEnvoyee;
    }

    useEffect(() => {
        if (conditionPourPasserEtapeSuivante()) {
            setEtapeCoordonnees(adresseResponsable, listeAdresses);
        }
    }, [
        isLoadingRenseignerAdressePrincipale,
        dataRenseignerAdressePrincipale,
        isLoadingJustificatifsDomicile,
        dataRenseignerJustificatifsDomicile,
        erreurJustificatifsDomicile,
    ]);

    const hasFormValid = () => {
        return (
            (watch('typeEtNomDeVoie') || watch('lieuDit')) &&
            dataCodePostal &&
            isValid &&
            !affichageFormulaire
        );
    };
    function postAdresse(donnees) {
        reinitialiseApi(CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE);
        postApi(
            usagerClientReducer,
            API_COMPTE_CREER_ADRESSE_PRINCIPALE_URL,
            donnees,
            CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE,
        );
    }

    const onSubmit = (dataForm) => {
        const adresseAverifier = {
            numeroVoie: dataForm.numeroDeVoie,
            libelleVoie: dataForm.typeEtNomDeVoie,
            codePostal: dataForm.codePostal,
            ville: dataForm.ville,
            extension: dataForm.extension,
            lieuDit: dataForm.lieuDit,
        };
        clearAlertes();
        setAdresseResponsable(dataForm);
        reinitialiseApi(CONTEXT_POST_VERIFIER_BAN);
        postApi(
            usagerClientReducer,
            API_POST_VERIFIER_BAN,
            adresseAverifier,
            CONTEXT_POST_VERIFIER_BAN,
        );
        setOuvrirModalBan(true);
    };

    const conserver = async () => {
        setOuvrirModalBan(false);
        const dataFormat = await formaterCreationAdressePrincipal(
            adresseResponsable,
            uuidBrouillon,
            false,
        );
        setJustificatifsDomicile(dataFormat.justificatifsDomicile);
        dataFormat.justificatifsDomicile = null;
        postAdresse(dataFormat);
        await onEtapeSuivante();
    };

    const remplacer = async () => {
        const dataFormat = await formaterCreationAdressePrincipal(
            adresseResponsable,
            uuidBrouillon,
            true,
        );
        dataFormat.numeroDeVoie = data.numeroVoie;
        dataFormat.typeEtNomDeVoie = data.libelleVoie;
        dataFormat.extension = data.extension;
        dataFormat.lieuDit = data.lieuDit;
        dataFormat.codePostal = data.codePostal;
        dataFormat.ville = data.ville;

        const champsARemplacer = {
            numeroDeVoie: data.numeroVoie,
            typeEtNomDeVoie: data.libelleVoie.toUpperCase(),
            extension: data.extension,
            lieuDit: data.lieuDit,
            codePostal: data.codePostal,
            ville: data.ville.toUpperCase(),
            email: dataFormat.email,
            numeroSia: dataFormat.numeroSia,
            telephonePrincipal: dataFormat.telephonePrincipal,
            telephoneSecondaire: dataFormat.telephoneSecondaire,
            immatriculationVehicule: dataFormat.immatriculationVehicule,
            typeJustificatifDomicile: dataFormat.typeJustificatifDomicile,
        };

        reset(champsARemplacer);

        setAdresseResponsable({
            ...adresseResponsable,
            ...champsARemplacer,
        });

        setOuvrirModalBan(false);
        setJustificatifsDomicile(dataFormat.justificatifsDomicile);
        dataFormat.justificatifsDomicile = null;
        await postAdresse(dataFormat);
    };

    return (
        <SegmentLoader
            isLoading={
                isLoading ||
                isLoadingRenseignerAdressePrincipale ||
                isLoadingJustificatifsDomicile ||
                isLoadingAjoutAdresseSecondaire
            }
        >
            {ouvrirModalBan && (
                <ModalBan
                    residence="principale"
                    fermerModal={fermerModal}
                    data={data}
                    isLoading={
                        isLoading ||
                        isLoadingRenseignerAdressePrincipale ||
                        isLoadingJustificatifsDomicile
                    }
                    remplacer={remplacer}
                    conserver={conserver}
                />
            )}
            {ouvrirModalBanSecondaire && (
                <ModalBan
                    residence="secondaire"
                    fermerModal={fermerModalSecondaire}
                    data={data}
                    isLoading={isLoading}
                    remplacer={remplacerSecondaire}
                    conserver={conserverSecondaire}
                />
            )}
            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col col={12}>
                            <InfoChampsObligatoire />
                        </Col>
                    </Row>
                    <Row>
                        <Col col={12}>
                            <h3>Adresse postale en France</h3>
                        </Col>
                    </Row>
                    <FormulaireAdresseSimple />
                    <FormulaireJustificatifsDomicile />
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <CheckboxControl
                                id="itinerant"
                                name="itinerant"
                                label="Itinérant"
                                value="itinerant"
                                {...register('itinerant', {
                                    onChange: ({ target }) => {
                                        if (!target.checked) {
                                            unregister('immatriculationVehicule');
                                        }
                                    },
                                })}
                            />
                            {watch('itinerant') && (
                                <div>
                                    <InputControl
                                        id="immatriculationVehicule"
                                        uppercase
                                        label="Immatriculation de votre résidence mobile terrestre"
                                        hintText="Caravane, camping-car,..."
                                        {...register('immatriculationVehicule', {
                                            required: getMessageErreurChampManquant(
                                                'Immatriculation du véhicule',
                                            ),
                                            setValueAs: (v) => v.toUpperCase(),
                                        })}
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>

                    <Row className="margin-top-lg">
                        <Col col={12}>
                            <h3>Informations</h3>
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="email"
                                id="email"
                                label="E-mail *"
                                hintText="Exemple: ministere.interieur@exemple.com"
                                type="text"
                                required
                                {...register('email', {
                                    required: getMessageErreurChampManquant('E-mail'),
                                    pattern: {
                                        value: REGEXP_EMAIL,
                                        message:
                                            "Le format de l'adresse mail n'est pas valide ( Exemple: ministere.interieur@exemple.com )",
                                    },
                                })}
                                state={formState.errors?.email ? 'error' : null}
                                message={formState.errors?.email?.message}
                            />
                        </Col>
                    </Row>
                    <Row gutters>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="tel-national"
                                id="telephonePrincipal"
                                label="Téléphone *"
                                hintText="Exemple: 0612345678"
                                required
                                type="text"
                                maxLength="10"
                                {...register('telephonePrincipal', {
                                    required: getMessageErreurChampManquant('Téléphone'),
                                })}
                                state={formState.errors?.telephonePrincipal ? 'error' : null}
                                message={formState.errors?.telephonePrincipal?.message}
                                maskFonction={getTelFormatWithoutSpace}
                            />
                        </Col>
                        <Col col={12} lg={6}>
                            <InputControl
                                autocomplete="tel-national"
                                id="telephoneSecondaire"
                                label="Téléphone"
                                hintText="Exemple: 0198765432"
                                type="text"
                                maxLength="10"
                                {...register('telephoneSecondaire')}
                                state={formState.errors?.telephoneSecondaire ? 'error' : null}
                                message={formState.errors?.telephoneSecondaire?.message}
                                maskFonction={getTelFormatWithoutSpace}
                            />
                        </Col>
                    </Row>

                    <Row className="margin-top-lg">
                        <Col col={12}>
                            <h3>Adresse secondaire de stockage d'armes</h3>
                        </Col>
                    </Row>

                    <TableAdressesComponent listeAdresses={listeAdresses} actions={getActions} />
                    {affichageFormulaire ? (
                        <>
                            <Row>
                                <Col col={12}>
                                    <InfoChampsObligatoire />
                                </Col>
                            </Row>
                            <FormulaireAdresseSimple prefix="adresseSecondaire" />
                            <Row className="margin-top-lg">
                                <Col>
                                    <ButtonGroup inline align="right">
                                        <Button
                                            name="Annuler"
                                            variant="secondary"
                                            onClick={cacherFormulaire}
                                        >
                                            Annuler
                                        </Button>
                                        <Button
                                            name="validerAdresse"
                                            type="button"
                                            variant="primary"
                                            disabled={!isValid}
                                            onClick={handleSubmit(verifierBan)}
                                        >
                                            Valider
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <div>
                            <Button
                                name="ajouterAdresse"
                                variant="primary"
                                onClick={afficherFormulaire}
                                icon="fr-icon-add-line"
                                iconPosition="left"
                                disabled={!hasFormValid()}
                            >
                                Ajouter une adresse de stockage des armes secondaire
                            </Button>
                        </div>
                    )}

                    <Row className="margin-top-lg">
                        <Col>
                            <ButtonGroup inline align="right">
                                <Button
                                    name="etapePrecedente"
                                    type="button"
                                    variant="secondary"
                                    isLoading={
                                        isLoading ||
                                        isLoadingRenseignerAdressePrincipale ||
                                        isLoadingJustificatifsDomicile
                                    }
                                    onClick={onRetourEtape}
                                >
                                    Retour
                                </Button>
                                <Button
                                    name="etapeSuivante"
                                    type="submit"
                                    variant="primary"
                                    isLoading={
                                        isLoading ||
                                        isLoadingRenseignerAdressePrincipale ||
                                        isLoadingJustificatifsDomicile
                                    }
                                    disabled={!hasFormValid()}
                                >
                                    Accéder à l'étape suivante
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                </form>
            </FormProvider>
        </SegmentLoader>
    );
};

CoordonneesDetenteurPhysique.propTypes = {
    uuidBrouillon: PropTypes.string.isRequired,
    postApi: PropTypes.func.isRequired,
    isAncienLicencie: PropTypes.bool,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    data: PropTypes.any,
    motifs: PropTypes.object.isRequired,
    retourEtape: PropTypes.func.isRequired,
    setEtapeCoordonnees: PropTypes.func.isRequired,
    isLoadingRenseignerAdressePrincipale: PropTypes.bool.isRequired,
    dataRenseignerAdressePrincipale: PropTypes.shape({
        uuidBrouillon: PropTypes.string.isRequired,
    }),
    isLoadingJustificatifsDomicile: PropTypes.bool,
    dataRenseignerJustificatifsDomicile: PropTypes.string.isRequired,
    erreurJustificatifsDomicile: PropTypes.bool,
    dataAdressePrincipaleRenseignee: PropTypes.shape({
        numeroDeVoie: PropTypes.string,
        typeEtNomDeVoie: PropTypes.string.isRequired,
        extension: PropTypes.string,
        lieuDit: PropTypes.string,
        codePostal: PropTypes.string.isRequired,
        ville: PropTypes.string.isRequired,
        typeJustificatif: PropTypes.string.isRequired,
        justificatifsDomicile: PropTypes.arrayOf(PropTypes.instanceOf(FileUploadeAbstract))
            .isRequired,
        itinerant: PropTypes.string,
        immatriculationVehicule: PropTypes.string,
        email: PropTypes.string,
        telephonePrincipal: PropTypes.string,
        telephoneSecondaire: PropTypes.string,
    }),
    dataCodePostal: PropTypes.bool,
    clearAlertes: hideAllNotification,
    isLoadingAjoutAdresseSecondaire: PropTypes.bool,
    dataAjoutAdresseSecondaire: PropTypes.shape({
        uuidBrouillon: PropTypes.string.isRequired,
    }),
    dataAdressesSecondairesRenseignee: PropTypes.arrayOf(
        PropTypes.shape({
            hasVerificationBan: PropTypes.bool,
            numeroDeVoie: PropTypes.string,
            typeEtNomDeVoie: PropTypes.string.isRequired,
            extension: PropTypes.string,
            lieuDit: PropTypes.string,
            codePostal: PropTypes.string.isRequired,
            ville: PropTypes.string.isRequired,
        }),
    ),
};
export default connect(
    (state) => {
        const { isLoading, data } = state.adresseVerificationBAN.verifier;
        const {
            isLoading: isLoadingRenseignerAdressePrincipale,
            data: dataRenseignerAdressePrincipale,
        } = state.compte.creer.renseignerAdressePrincipale;
        const { isLoading: isLoadingAjoutAdresseSecondaire, data: dataAjoutAdresseSecondaire } =
            state.compte.creer.ajoutAdresseSecondaire;
        const {
            data: dataRenseignerJustificatifsDomicile,
            isLoading: isLoadingJustificatifsDomicile,
            erreur: erreurJustificatifsDomicile,
        } = state.compte.creer.renseignerJustificatifsDomicile;
        const { data: dataCodePostal } = state.monCompte.verifierCodePostal;
        return {
            isLoading,
            data,
            isLoadingRenseignerAdressePrincipale,
            dataRenseignerAdressePrincipale,
            isLoadingJustificatifsDomicile,
            dataRenseignerJustificatifsDomicile,
            erreurJustificatifsDomicile,
            dataCodePostal,
            isLoadingAjoutAdresseSecondaire,
            dataAjoutAdresseSecondaire,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
        clearAlertes: hideAllNotification,
    },
)(CoordonneesDetenteurPhysique);
